import { gql } from '../../../__generated__';

export const CREATE_FEEDBACK = gql(/* GraphQL */ `
  mutation CreateFeedback($data: FeedbackInput!) {
    createFeedback(data: $data) {
      documentId
      suggestedFactCheck
      suggestedReasoning
      factClientComments
      categoryClientComments
      sexuallyClientComments
      religiousClientComments
      factUpvote
      factDownvote
      categoryUpvote
      categoryDownvote
      sexuallyUpvote
      sexuallyDownvote
      religiousUpvote
      religiousDownvote
      suggestedCategory
      suggestedRating
      deletedAt
      uuid
      sexuallyFirstPersonPerspective
      sexuallyPhysicalContactType
      sexuallySetting
      sexuallyExplicitTermsFound
      sexuallyAnatomicalTermsPresent
      sexuallyContainsDialogue
      sexuallyExplicitTermsList
      sexuallyAnatomicalTermsList
      sexuallyChromosomallyDefinedGender
      sexuallySelfIdentifiedGenders
      sexuallySexualRelationshipType
      sexuallyCharacterAge
      sexuallyEuphemismsList
      sexuallySuggestivePhrasesList
      sexuallyPowerImbalancePresent
      sexuallyTone
      sexuallyExcessiveFocusOnBodyDescription
      sexuallyLanguageOfSecrecyOrConcealment
      sexuallyRoleplayOrFantasyContext
      sexuallyViolenceOverlap
      sexuallyNudityDetected
      sexuallyNudityExtent
      sexuallyNudityType
      sexuallySexualActsDetected
      sexuallyIntentDetected
      sexuallyRatingReason
      religiousReligionKeywordsFound
      religiousKeywordList
      religiousReligionsNamed
      religiousFirstOrSecondPersonPronouns
      religiousMiracleMentionedHow
      religiousExplicitOrImplicit
      religiousWhoSaysIt
      religiousTone
      religiousToneConfidence
      religiousReligiousSlangFound
      religiousReligiousSlangList
      religiousHistoricSlursFound
      religiousHistoricSlurList
      religiousMetaphoricReligiousTermFound
      religiousMetaphoricReligiousTermList
      religiousDisrespectTowardsReligion
      religiousDisrespectTriggerList
      religiousDisrespectedReligions
      religiousComparisonFrameDetected
      religiousComparedReligions
      religiousDoctrineClaimType
      religiousFramingStrength
      religiousDraftStanceByReligion
      religiousOverallBiasScore
      religiousReasonNote
      createdAt
      updatedAt
      publishedAt
    }
  }
`);
